import React from 'react'

export const RootModalContext = React.createContext({
    onRequestClose: () => {},
})
